import React from 'react';
import { Header, QuiltedList, Section } from '@components';
import { Button } from '@mui/material';
import { DownloadRounded } from '@mui/icons-material';
const MediaDownloadBlock = ({ header, gallery, cta }) => {
  const url =
    cta?.href ??
    cta?.externalLink ??
    cta?.file?.data?.attributes?.url;
  return (
    <Section className={'pb-20'}>
      <Header {...header} />
      <QuiltedList gallery={gallery.data} />

      {cta && (
        <div
          className={'flex flex-col justify-center items-center'}
        >
          <Button target="_blank" href={url}>
            <DownloadRounded className="mr-2" />
            <span className="text-lg uppercase">{cta?.label}</span>
          </Button>
        </div>
      )}
    </Section>
  );
};

export default MediaDownloadBlock;
